export default __webpack_public_path__ + "static/media/image4.bd5c01ac.jpg";